import DocPageLayout from './DocPageLayout.js';
import {
  WarningAmberOutlined,
  HealthAndSafetyOutlined,
  EmojiObjectsOutlined
} from '@mui/icons-material';
import './DocPage.css';

const heroImage = '/img/full-body-balance.webp';

const symptomSections = [
  {
    icon: WarningAmberOutlined,
    title: '膝が痛い時にやってはいけないこと',
    description: [
      '無理な運動やスポーツの継続、階段の反復は痛みを悪化させやすい。',
      '同じ姿勢で長時間過ごすのはNG。合間に軽いストレッチや歩行で関節を動かす。',
      'クッション性の乏しい靴・不適切な歩行姿勢は膝への衝撃を増やすため避ける。',
      '冷やしすぎ・強い痛み時の無理なストレッチやマッサージは逆効果になりうる。',
      '「そのうち治る」と放置せず、早めの評価と対処を。'
    ]
  },
  {
    icon: HealthAndSafetyOutlined,
    title: '膝痛のよくある原因（傾向）',
    description: [
      '運動不足や座りがちな生活：筋力低下で関節負担が増える。',
      '体重増加：歩行や階段で体重の数倍の力が膝にかかる。',
      '加齢変化：軟骨のすり減りで痛みを感じやすくなる。',
      'スポーツ・立ち仕事：使い過ぎや荷重による炎症・損傷が起こりやすい。',
      '不適切な姿勢・歩き方：膝への偏ったストレスを生む。'
    ]
  },
  {
    icon: HealthAndSafetyOutlined,
    title: '膝痛の主な原因疾患（例）',
    description: [
      '変形性膝関節症：筋力低下・加齢・肥満などを契機に軟骨や半月板の適合不良・炎症で痛む。',
      '半月板損傷：クッション役の半月板が損傷し、曲げ伸ばし痛や引っかかり、関節液貯留・ロッキングを起こすことがある。',
      'タナ障害：滑膜ひだの炎症で曲げ伸ばしや捻り動作で痛みが徐々に増える。',
      '鵞足炎：膝内側下部（3本の腱の付着部）の炎症。圧痛・腫れ・可動制限を伴う。',
      '靱帯損傷：内側／外側側副靱帯、前十字靱帯などの損傷で痛み・腫れ・不安定感や膝くずれ。',
      'スポーツ起因：ジャンパー膝（膝蓋靱帯炎）／ランナー膝（腸脛靱帯炎）など。'
    ]
  },
  {
    icon: EmojiObjectsOutlined,
    title: '膝の施術の進め方',
    steps: [
      '問診・徒手検査で痛みの部位と誘因を特定（姿勢・歩行・生活習慣も確認）。',
      '筋・筋膜、骨盤〜下肢アライメントを整え、必要に応じて神経の伝達異常にアプローチ（神経整体）を実施。',
      '自宅ケア（負担の少ない動かし方・靴や姿勢の見直し）を指導し、再発を予防。'
    ]
  }
];

const SymptomKneePain = () => (
  <DocPageLayout
    currentRoute="/symptoms/knee-pain"
    pageTitle="膝の痛み"
    heroImage={heroImage}
    heroImageAlt="膝痛で悩む方"
    heroHighlight="膝が痛い時、どうすれば？"
    heroDescription={[
      '立ち上がり・階段・正座などで膝に違和感や痛みが出る場合、放置は悪化の原因になります。原因の多くは生活動作の負担や使い過ぎ、加齢変化・体重など複合要因です。',
      '評価と施術で負担を減らし、再発しにくい使い方へ整えていきます。'
    ]}
  >
    {symptomSections.map(({ icon: Icon, title, description, steps }) => (
      <article key={title} className="doc-section">
        <h3 className="doc-section__title">
          <Icon className="doc-section__icon" />
          {title}
        </h3>
        <div className="doc-section__body">
          {description && description.map((text) => <p key={text}>{text}</p>)}
          {steps && (
            <ol className="doc-ordered-list">
              {steps.map((step) => (
                <li key={step}>{step}</li>
              ))}
            </ol>
          )}
        </div>
      </article>
    ))}
    <p className="doc-final-note">当院の、膝痛施術を受けて頂くことをお勧めします。</p>
    <div className="doc-page__cta">
      <a
        className="doc-reservation-button"
        href="https://book.squareup.com/appointments/hqjlguwjlxeenh/location/MH09XMWCMM5H9/services"
        target="_blank"
        rel="noopener noreferrer"
      >
        ご予約はこちら
      </a>
    </div>
  </DocPageLayout>
);

export default SymptomKneePain;
